(function () {

    angular
        .module('invesfleet')
        .run(['$rootScope', function ($rootScope) {
            var strings = {};
            //Cadenas español
            var es = {};
            es.FLOTA = 'Flota';

            strings['ES'] = es;
            /*jshint camelcase: false */
            $rootScope.t_s = strings['ES'];
        }]);
})();